// extracted by mini-css-extract-plugin
module.exports = {"pickup-box-form-title":"PickupBoxFormPage_pickup-box-form-title__19MWh"};